import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LabelStyled,
  TextStyled,
} from "../../../styled/Elements";
import { Modal } from "react-bootstrap";
import styled from "styled-components";

const ReferralOpenModal = ({ show, onHide, note }) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onHide} centered>
      <ReferralModalWrapper>
        <Box className="p-4">
          <Box className="mb-4">
            <Box>
              <HeadingStyled size="24px" weight="bold" color="var(--text)">
                {t("Referral Note Detail")}
              </HeadingStyled>
            </Box>
          </Box>

          <TextStyled size="16px" color="var(--text2)">
            {note}
          </TextStyled>

          <Box className="d-flex justify-content-end">
            <Box className="mt-4 d-flex gap-3">
              <ButtonStyled
                label={t("Cancel")}
                bg={"var(--bgSecondary)"}
                color={"var(--text2)"}
                onClick={onHide}
              />
            </Box>
          </Box>
        </Box>
      </ReferralModalWrapper>
    </Modal>
  );
};

export default ReferralOpenModal;

const ReferralModalWrapper = styled.div``;
